import React, { useContext } from 'react';
import type { GridApi } from 'ag-grid-community';

import { useIsDataTable } from 'components/DataTable';
import { isSecondaryDimensionAInEffect } from 'components/V5GadgetForm/isSecondaryDimensionAEligible';
import FeatureGatesContext from 'contexts/FeatureGatesContext';

import useMatrixContent from './useMatrixContent';
import MatrixDataTableView from './MatrixDataTableView';
import MatrixView from './MatrixView';

const MatrixContentContainer = ({
  chartDefinition,
  gridApi,
  setGridApi,
  setExportHandle,
}: {
  chartDefinition: V5ChartDefinition;
  gridApi?: GridApi;
  setGridApi: React.Dispatch<React.SetStateAction<GridApi | undefined>>;
  setExportHandle: (handle: DataTable.ExportHandle | undefined) => void;
}) => {
  const { isDataTableEnabled } = useContext(FeatureGatesContext);
  // Stacked secondary rows only draw with DataTable: on a gated account, such
  // a matrix draws with it for everyone, whatever the matrix's rollout stage
  // (and flat, on AG, off the gate or where staff choose AG)
  const isStackRequested =
    !!chartDefinition.isSecondaryRowsStacked &&
    isSecondaryDimensionAInEffect(chartDefinition);
  const isDataTable = useIsDataTable('v5Matrix', {
    isOnForGatedAccount: isStackRequested,
  });
  const isSecondaryRowsStacked =
    isStackRequested && isDataTable && isDataTableEnabled;
  const props = useMatrixContent({
    chartDefinition,
    gridApi,
    setGridApi,
    isSecondaryRowsStacked,
  });

  if (isDataTable) {
    return (
      <MatrixDataTableView
        {...props}
        chartDefinition={chartDefinition}
        setExportHandle={setExportHandle}
        isSecondaryRowsStacked={isSecondaryRowsStacked}
      />
    );
  }

  return <MatrixView {...props} />;
};

export default MatrixContentContainer;
